<template>
  <div style="width: 100%"><highcharts :options="word()"></highcharts></div>
</template>

<script>
export default {
  props: ["data"],
  methods: {
    ColorScale() {
      // this.wordcloud = [];
      // for (const [key, value] of Object.entries(resp.data.countWord)) {
      //   this.wordcloud.push({
      //     name: key,
      //     weight: value,
      //   });
      // }
      // let data = this.wordcloud;
      // var makeScale = function (domain, range) {
      //   var minDomain = domain[0];
      //   var maxDomain = domain[1];
      //   var rangeStart = range[0];
      //   var rangeEnd = range[1];
      //   return (value) => {
      //     return (
      //       rangeStart +
      //       (rangeEnd - rangeStart) *
      //         ((value - minDomain) / (maxDomain - minDomain))
      //     );
      //   };
      // };
      // /**
      //  * Find min and max weight using reduce on data array
      //  */
      // var minWeight = data.reduce(
      //   (min, word) => (word.weight < min ? word.weight : min),
      //   data[0].weight
      // );
      // var maxWeight = data.reduce(
      //   (max, word) => (word.weight > max ? word.weight : max),
      //   data[0].weight
      // );
      // var scale = makeScale([minWeight, maxWeight], [0.3, 1]);
      // var scaleGreen = makeScale([minWeight, maxWeight], [150, 85]);
      // /**
      //  * creating a new, scaled data array
      //  */
      // var scaledData = data.map((word) => ({
      //   name: word.name,
      //   weight: word.weight,
      //   color: `rgba(33, ${scaleGreen(word.weight)}, 19,${scale(word.weight)})`,
      // }));
      // this.wordcloud = scaledData;
    },
    word() {
      let list = [];
      for (const [key, value] of Object.entries(this.data.data)) {
        list.push({
          name: key,
          weight: value,
          dataLabels: {
            enabled: true,
            useHTML: true,
          },
        });
      }
      return {
        chart: {
          style: {
            fontFamily: "Mitr",
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<span style="color:{point.color}">●</span> Occurrences: <b>{point.weight}</b><br/>',
        },
        title: {
          useHTML: true,
          text: this.data.title.text,
          style: {
            'word-break': "break-word",
            "text-align": "center",
          },
        },
        series: [
          {
            type: "wordcloud",
            data: list,
            rotation: {
              from: 0,
              to: 0,
            },
            maxFontSize: 18,
            minFontSize: 7,
            style: {
              fontFamily: "Mitr",
            },
          },
        ],
        // colors: ['#3c9a4b'],
      };
    },
  },
};
</script>

<style lang="scss" scoped>
</style>